import React from 'react'
import Select from '@/components/Select'
import { MemberInfo, RoleInfo } from '@/types'
import { Column, ColumnAction } from '@/components/Table'
import { ConfirmButton } from '@/components/Button'

export const memberColumns: (
  callback: (action: ColumnAction, data: MemberInfo) => () => void
) => Column<MemberInfo & { action?: unknown }>[] = (callback) => [
  {
    id: 'nickname',
    label: '用户名',
    width: 100,
    ellipsis: true,
  },
  {
    id: 'name',
    label: '姓名',
    width: 100,
  },
  {
    id: 'roles',
    label: '角色',
    // @ts-ignore
    format: ({
      row,
      value,
    }: {
      row: MemberInfo;
      value: Pick<RoleInfo, 'id' | 'name'>[];
    }) => {
      return (
        <Select
          sx={{ width: '100%' }}
          onFocus={callback('edit', row)}
          multiple={true}
          value={value?.map((item) => item?.id)}
          options={value?.map((item) => ({ label: item.name, value: item.id }))}
        />
      )
    },
  },
  {
    id: 'last_logined_at',
    label: '最近登录时间',
    width: 200,
  },
  {
    id: 'action',
    label: '操作',
    width: 120,
    format: ({ row }: { row: MemberInfo; value: unknown }) => {
      return (
        <ConfirmButton
          sx={{ zIndex: 'unset!important' }}
          danger='true'
          onClick={callback('delete', row)}
        >
          删除
        </ConfirmButton>
      )
    },
  },
]
